<template>
    <div class="content_box mobile_content">
        <div class="content deal-timer ">
            <div class="title_box">
                <div class="title">
                    <span>工单处理耗时统计</span>
                    <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                        <div slot="content">
                            <el-form label-position="left" :label-width="$store.state.type == 'pc' ? '150px' : '110px'">
                                <el-form-item label="新建工单量">
                                    <span>筛选时间内，新创建的工单数</span>
                                </el-form-item>
                                <el-form-item label="受理中工单量">
                                    <span>筛选时间内，工单状态为受理中的工单数</span>
                                </el-form-item>
                                <el-form-item label="已完结工单量">
                                    <span>筛选时间内，工单状态为已完结的工单数</span>
                                </el-form-item>
                                <el-form-item label="完结率">
                                    <span>筛选时间内，已完结工单量/新建工单量</span>
                                </el-form-item>
                                <el-form-item label="完结总时长">
                                    <span>筛选时间内，已完结工单花费的时间之和</span>
                                </el-form-item>
                                <el-form-item label="平均完结耗时">
                                    <span>筛选时间内，每个已完结工单的平均花费时长</span>
                                </el-form-item>
                                <el-form-item label="平均首次响应时长">
                                    <span>筛选时间内，触发首次响应动作的每个工单的平均花费时长</span>
                                </el-form-item>
                            </el-form>
                        </div>
                        <img class="icon-tip" v-if="$store.state.type == 'pc'" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                    </el-tooltip>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form">
                    <el-form-item label="">
                        <DatePicker :date="overviewTime" max="31" @dateSelect="dateSelect"></DatePicker>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchData.product_id" placeholder="请选择">
                            <el-option :label="item.product_name" :value="item.product_id" v-for="item in product" :key="item.product_id + '123'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                        <div class="button search export" @click="exportFile" v-if="roleCheck('101-101-102-102') && $store.state.type == 'pc'">
                            <span>导出</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="key" label="日期" min-width="100px"></el-table-column>
                <el-table-column prop="create" label="新建工单量" ></el-table-column>
                <el-table-column prop="run" label="受理中工单量" min-width="100px"></el-table-column>
                <el-table-column prop="end" label="已完结工单量" min-width="100px"></el-table-column>
                <el-table-column prop="end_per" label="完结率" ></el-table-column>
                <el-table-column prop="all_time_sum" label="完结总时长" ></el-table-column>
                <el-table-column prop="all_time_avg" label="平均完结耗时" min-width="100px"></el-table-column>
                <el-table-column prop="first_time_avg" label="平均首次响应时长" width="150"></el-table-column>
            </el-table>
        </div>
    </div>
    
</template>
<script>
export default({
    name: 'deal-timer',
    data() {
        return {
            searchData: {
                product_id: '',
                start_time: 0,
                end_time: 0,
                zone: this.timezone,
            },
            product: [],
            overviewTime: '',
            listData: [],
            total: 0
        }
    },
    watch: {
        'overviewTime' : function (nTime, oTime) {
            if(nTime.length > 1) {
                this.searchData.start_time = nTime[0];
                this.searchData.end_time = nTime[1];
            }else{
                this.searchData.start_time = 0;
                this.searchData.end_time = 0;
            }
            if(this.searchData.product_id) {
                this.getWorkTimer();
            }
        }
    },
    created() {
        this.getProductCate();
    },
    methods: {
        search() {
            this.getWorkTimer();
        },
        dateSelect(date) {
            this.overviewTime = [...date];
        },
        getProductCate() {
            this.api.getProductCate({}).then(data => {
                this.product = data.data.productCateInfos;
                this.searchData.product_id = this.product[0].product_id;
                this.overviewTime = this.setDate(7);
            })
        },
        getWorkTimer() {
            this.api.getWorkTimer(this.searchData).then(data => {
                this.listData = data.data;
            })
        },
        exportFile() {
            this.api.timeInfoExport(this.searchData).then(data => {})
        }
    }
})
</script>
<style lang="less" scoped>
    .title{
        .flexLayout(flex-satrt);
    }
</style>



// WEBPACK FOOTER //
// src/view/order/overview/deal-timer.vue